<template>
  <v-dialog v-model="dialog" scrollable width="500">
    <BaseBodyDialog title="Chi tiết lịch nghỉ" :isActionsShown="false" @close="closeDialog">
      <div class="py-4">
        <div>
          <div class="text-body-2 font-weight-medium mb-3">Thông tin cơ bản</div>
          <div class="d-flex">
            <VacationDetailInfo title="Lớp" :value="$_get(item, 'class.title')" style="width: 50%" />
            <VacationDetailInfo
              title="Ngày nghỉ"
              :value="$options.filters.ddmmyyyy($_get(item, 'date', ''))"
              style="width: 50%"
            />
          </div>
          <VacationDetailInfo title="Ghi chú" :value="$_get(item, 'notes', '')" style="width: 100%" class="mt-2" />
        </div>
        <v-divider class="my-2" v-if="$_get(item, 'isMakeup', false)" />
        <div v-if="$_get(item, 'isMakeup', false)">
          <div class="text-body-2 font-weight-medium mb-3">Thông tin học bù</div>
          <div class="d-flex">
            <VacationDetailInfo
              title="Ngày học"
              :value="$options.filters.ddmmyyyy($_get(item, 'makeupDate', ''))"
              style="width: 50%"
            />
            <VacationDetailInfo
              title="Thời gian"
              :value="`${$_get(item, 'makeupStartTime', '-')} - ${$_get(item, 'makeupEndTime', '-')}`"
              style="width: 50%"
            />
          </div>

          <VacationDetailInfo class="mt-2" title="Phòng học" :value="$_get(item, 'makeupClassroom.name', '-')" />
          <VacationDetailInfo
            class="mt-2"
            title="Giáo viên"
            :value="
              $_get(item, 'makeupTeachers', [])
                .map((i) => i.name)
                .join(',')
            "
          />
        </div>
      </div>
    </BaseBodyDialog>
  </v-dialog>
</template>
<script>
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import VacationDetailInfo from './VacationDetailInfo.vue'
import { mapActions } from 'vuex'

export default {
  components: { BaseBodyDialog, VacationDetailInfo },
  data: () => ({ dialog: false, item: null }),
  methods: {
    ...mapActions({ findOneIndependent: 'scheduleVacation/findOneIndependent' }),
    async openDialog(id) {
      this.item = await this.findOneIndependent(id)
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
  },
}
</script>
